const Subject = () =>
  import(
    /* webpackChunkName: "base-info-crm-subject" */ '@/pages/base-info/crm/subject/index.vue'
  )
const CreateSubject = () =>
  import(
    /* webpackChunkName: "base-info-crm-subject" */ '@/pages/base-info/crm/subject/create.vue'
  )
const EditSubject = () =>
  import(
    /* webpackChunkName: "base-info-crm-subject" */ '@/pages/base-info/crm/subject/edit.vue'
  )

export default {
  path: 'subject',
  meta: {
    label: 'subject',
    auth: 'subject'
  },
  component: {
    name: 'Subject',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BaseInfoCrmSubject',
      path: '/',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Subject
    },
    {
      name: 'BaseInfoCreateCrmSubject',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateSubject
    },
    {
      name: 'BaseInfoEditCrmSubject',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditSubject,
      props: true
    }
  ]
}
